import {
	comMapping
} from "@/components/util/Function/comMapping";
export function getdata() {
	var obj = {
		searchlist: [{
				prop: "businessMatchStatus",
				label: '处理状态',
				type: "select",
				selectval: comMapping.$businessMatchStatus
			},
			{
				prop: "businessType",
				label: '业务类型',
				type: "select"
			},
			{
				prop: "companyCode",
				label: '公司编号',
				type: "selectmore",
				width: "220px",
			},
			{
				prop: "fapzl",
				label: '发票种类',
				type: "select",
				selectval: comMapping.$fapzl
			},
			{
				prop: "kaiprq",
				label: '开票日期',
				type: "date",
				valueformat: 'yyyyMMdd'
			},
			{
				prop: "faphm",
				label: '发票号码',
				type: "input"
			},
			{
				prop: "faplx",
				label: '发票类型',
				type: "select",
				selectval: comMapping.$fplx
			},
			{
				prop: "postingDate",
				label: '记账日期',
				type: "date",
				valueformat: 'yyyy-MM-dd'
			},
			{
				prop: "businessMatchRemark",
				label: '备注',
				type: "input"
			},
			{
				prop: "billingNo",
				label: 'billing号',
				type: "input"
			},
			{
				prop: "voucherDate",
				label: '凭证日期',
				type: "date",
				valueformat: 'yyyy-MM-dd'
			},
			{
				prop: "accountCode",
				label: '科目代码',
				type: "input"
			},
			{
				prop: "voucherNo",
				label: '凭证号',
				type: "input"
			},
			{
				prop: "voucherDesc",
				label: '凭证摘要',
				type: "input"
			}
		],
		searchdata: {
			businessMatchStatus: "",
			businessType: "",
			companyCode: "",
			postingDate: [],
			fapzl: "",
			voucherDate: [],
			faphm: "",
			kaiprq:[],
			faplx: "",
			businessMatchRemark: "",
			billingNo: "",
			accountCode: "",
			voucherNo: "",
			voucherDesc: ""
		},
		headData: [{
				title: "公司编号",
				prop: "companyCode",
				width: "80",
				custom: true
			},
			{
				title: "发票号码",
				prop: "faphm",
				width: "170",
				custom: true
			},
			{
				title: "开票日期",
				custom: true,
				prop: "kaiprq",
				width: 110,
			},
			{
				title: "备注",
				prop: "businessMatchRemark",
				width: "110",
				custom: true
			},
			{
				title: "发票税额",
				prop: "shuiehj",
				width: "110",
				custom: true
			},
			{
				title: "凭证金额",
				prop: "localAmount",
				width: "110",
				custom: true
			},
			{
				title: "业务类型",
				custom: true,
				prop: "businessType",
				width: 100,
			},
			{
				title: "处理状态",
				custom: true,
				prop: "businessMatchStatus",
				width: 100,
			},
			{
				title: "科目代码",
				prop: "accountCode",
				width: "110",
				custom: true
			},
			{
				title: "凭证号",
				custom: true,
				prop: "voucherNo",
				width: 110,
			},
			{
				custom: true,
				title: "记账日期",
				prop: "postingDate",
				width: 110,
			},
			{
				custom: true,
				title: "凭证日期",
				prop: "voucherDate",
				width: 110,
			},
			{
				title: "凭证摘要",
				custom: true,
				prop: "voucherDesc",
				width: 110,
			},
			{
				title: "billing号",
				custom: true,
				prop: "billingNo",
				width: 100,
			},
			{
				title: "参考字段一",
				custom: true,
				prop: "cank1",
				width: 100,
			},
			{
				title: "参考字段二",
				custom: true,
				prop: "cank2",
				width: 100,
			},
			{
				title: "参考字段三",
				custom: true,
				prop: "cank3",
				width: 100,
			},
			{
				title: "参考字段四",
				custom: true,
				prop: "cank4",
				width: 100,
			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		}
	}
	return obj
}
